import { OrderLineItemFragment } from '#src/generated/graphql'
import keys from 'lodash/keys'

export function getFilteredLineItems(lineItems: OrderLineItemFragment[]) {
  return lineItems.filter(
    lineItem =>
      !['OrderLineItemShipmentSource', 'OrderLineItemExpertTipSource'].includes(
        lineItem.source.__typename
      )
  )
}

export interface GroupedLineItemsType {
  parentLineItem: OrderLineItemFragment
  children: OrderLineItemFragment[]
}

export function groupLineItems({
  lineItems,
  includeTip = false,
  includeShipping = false
}: {
  lineItems: OrderLineItemFragment[]
  includeTip?: boolean
  includeShipping?: boolean
}) {
  const orderLineItemTree: {
    [key: string]: GroupedLineItemsType
  } = {}

  lineItems.forEach(orderLineItem => {
    if (!includeTip && orderLineItem.source.__typename === 'OrderLineItemExpertTipSource') return
    if (!includeShipping && orderLineItem.source.__typename === 'OrderLineItemShipmentSource')
      return

    if (orderLineItem.isGroup) {
      // If it's a group, it gets it's own ID, overwrite?
      orderLineItemTree[orderLineItem.id] = {
        parentLineItem: orderLineItem,
        children: []
      }
    } else {
      if (orderLineItem.parentId && orderLineItemTree[orderLineItem.parentId]) {
        orderLineItemTree[orderLineItem.parentId].children.push(orderLineItem)
      } else {
        orderLineItemTree[orderLineItem.id] = { parentLineItem: orderLineItem, children: [] }
      }
    }
  })

  return keys(orderLineItemTree).map(lineItemTree => orderLineItemTree[lineItemTree])
}
